import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class CustomvalidationService {


    ValidPassword(passwordControlName: string, cpasswordControlName: string) {
        return (formGroup: FormGroup) => {
            const passwordControl = formGroup.controls[passwordControlName];
            if (passwordControl.errors && !passwordControl.errors.invalidPassword) {
                return;
            }

            const cpasswordControl = formGroup.controls[cpasswordControlName];
            if (cpasswordControl.errors && !cpasswordControl.errors.invalidPassword) {
                return;
            }

            /* var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@@#-\$%\^&\*\-])(?=.{8,})");*/
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
            if (!passwordControl.value.match(strongRegex)) {
                passwordControl.setErrors({ invalidPassword: true });
            }
            else {
                passwordControl.setErrors(null);

                if (passwordControl.value != cpasswordControl.value) {
                    cpasswordControl.setErrors({ invalidPassword: true });
                }
                else {
                    cpasswordControl.setErrors(null);
                }
            }
        }
    }
    decimalUpTo15PlaceValidation(control: AbstractControl) {
        if (control.value.match(/^-?\d*\.?\d{0,15}$/g)) {
            return null;
        } else {
            return { 'onlyDecimalAllowed': true };
        }
    }
    decimalUpTo25PlaceValidation(control: AbstractControl) {
        if (control.value.match(/^-?\d*\.?\d{0,25}$/g)) {
            return null;
        } else {
            return { 'onlyDecimalAllowed': true };
        }
    }
    positiveDecimalUpTo15PlaceValidation(control: AbstractControl) {
        if (control.value.match(/^\d*\.?\d{0,15}$/g)) {
            return null;
        } else {
            return { 'onlyDecimalAllowed': true };
        }
    }
    timeFormatValidation(control: AbstractControl) {
        return moment(control.value, "HH:mm", true).isValid();

    }
    public noWhitespaceValidator(control: AbstractControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
    public onlytimeFormatValidation(control: AbstractControl) {
        if (control.value.match(/^(?:(?:([01]?\d|2[0-3]){2}:)?([0-5][0-5]?\d):)?([0-5][0-5]?\d)$/g)) {
            return null;
        } else {
            return { 'onlytimeAllowed': true };
        }
    }
    public ValidEmail(control: AbstractControl) {
        if (control.value.trim() == "" || control.value.trim().match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            return null;
        } else {
            return { 'email': true };
        }
    }
}